import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { PartnerLaneSortConfigurationOrchestration } from '@shipium-corp/shipium-ts-types';

export interface DockLaneSortConfigurationsModel {
  dockLaneSortConfigurationsMap: Record<string, PartnerLaneSortConfigurationOrchestration>;
  setDockLaneSortConfigurations: Action<DockLaneSortConfigurationsModel, PartnerLaneSortConfigurationOrchestration[]>;
  setDockLaneSortConfiguration: Action<DockLaneSortConfigurationsModel, PartnerLaneSortConfigurationOrchestration>;
  fetchDockLaneSortConfigurationsLoading: boolean;
  setFetchDockLaneSortConfigurationsLoading: Action<DockLaneSortConfigurationsModel, boolean>;
  fetchDockLaneSortConfigurations: Thunk<DockLaneSortConfigurationsModel, void, Injections, StoreModel, Promise<void>>;
  fetchDockLaneSortConfigurationsFailure: Action<DockLaneSortConfigurationsModel, ApplicationErrorOptions>;
}

export const dockLaneSortConfigurationsModel: DockLaneSortConfigurationsModel = {
  dockLaneSortConfigurationsMap: {},
  setDockLaneSortConfigurations: action((state, dockLaneSortConfigurations) => {
    const dockLaneSortConfigurationsMap = dockLaneSortConfigurations.reduce<
      Record<string, PartnerLaneSortConfigurationOrchestration>
    >((acc, curr) => {
      acc[curr.laneSortConfigurationId as string] = curr;
      return acc;
    }, {});
    state.dockLaneSortConfigurationsMap = dockLaneSortConfigurationsMap;
  }),
  setDockLaneSortConfiguration: action((state, dockLaneSortConfiguration) => {
    state.dockLaneSortConfigurationsMap[dockLaneSortConfiguration.laneSortConfigurationId as string] =
      dockLaneSortConfiguration;
  }),
  fetchDockLaneSortConfigurationsLoading: false,
  setFetchDockLaneSortConfigurationsLoading: action((state, isLoading) => {
    state.fetchDockLaneSortConfigurationsLoading = isLoading;
  }),
  fetchDockLaneSortConfigurations: thunk(async (actions, payload, { injections }) => {
    try {
      actions.setFetchDockLaneSortConfigurationsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchDockLaneSortConfiguration();
      actions.setDockLaneSortConfigurations(response.results ?? []);
      actions.setFetchDockLaneSortConfigurationsLoading(false);
      return response;
    } catch (error) {
      actions.fetchDockLaneSortConfigurationsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error instanceof Error ? error.message : 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchDockLaneSortConfigurationsLoading(false);
      return error;
    }
  }),
  fetchDockLaneSortConfigurationsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default dockLaneSortConfigurationsModel;
